module.exports = __webpack_public_path__ + "static/media/aryan.8e83cb08.jpeg";